// extracted by mini-css-extract-plugin
export default {"button":"_1qCNo7At","disabled":"_1lrfYPcp"};